import { render } from "./DiscussionsAndForumsBox.vue?vue&type=template&id=ede22ba6&scoped=true"
import script from "./DiscussionsAndForumsBox.vue?vue&type=script&lang=js"
export * from "./DiscussionsAndForumsBox.vue?vue&type=script&lang=js"

import "./DiscussionsAndForumsBox.vue?vue&type=style&index=0&id=ede22ba6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede22ba6"]])

export default __exports__